'use client';

import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { findEmailSuggestion } from '~/lib/emailSuggestion';

interface Props {
    name: string;
    message: string;
    onAccept?: (value: string) => void;
}

// preflight is off, so the browser's button chrome has to be undone by hand
const linkButton =
    'tw-inline tw-appearance-none tw-bg-transparent tw-border-0 tw-p-0 tw-m-0 tw-text-current tw-cursor-pointer tw-underline';
const inheritFont = { fontFamily: 'inherit', fontSize: 'inherit', lineHeight: 'inherit' };

export const EmailSuggestionMessage = ({ name, message, onAccept }: Props) => {
    const { t } = useTranslation('common');
    const { setValue, clearErrors } = useFormContext();
    const value = useWatch({ name });
    const match = findEmailSuggestion(message, value);

    if (!match) return <>{message}</>;

    const accept = () => {
        setValue(name, match.suggestion, { shouldDirty: true });
        clearErrors(name);
        onAccept?.(match.suggestion);
    };

    // the backend skips the typo check when <field>_confirmed equals the submitted address
    const confirm = () => {
        setValue(`${name}_confirmed`, value);
        clearErrors(name);
    };

    return (
        <>
            {match.before}
            <button type="button" className={`${linkButton} tw-font-semibold`} style={inheritFont} onClick={accept}>
                {match.suggestion}
            </button>
            {match.after}{' '}
            <button type="button" className={linkButton} style={inheritFont} onClick={confirm}>
                {t('emailTypoConfirm')}
            </button>
        </>
    );
};

export default EmailSuggestionMessage;
